module.exports = __webpack_public_path__ + "img/Landing_Page_step_04.465e224b.jpg";